import { i18n } from '@/config';

export function normalizeLocale(locale: string) {
  const normalized = locale.toLowerCase().replace(/[^a-z]/g, '-');
  if (i18n.locales.includes(normalized)) {
    return normalized;
  }
  return i18n.locales.find((loc) => loc.startsWith(normalized)) ?? i18n.defaultLocale;
}
